const MESSAGES = {
    pending: (o) => `we've received your order ${o.order_number} (${o.bundle_label}). We'll confirm it shortly.`,
    confirmed: (o) => `your order ${o.order_number} is confirmed and being packed. Total: ${Number(o.total_price).toLocaleString()} PKR.`,
    shipped: (o) =>
        `your order ${o.order_number} has been shipped and will arrive in 1-3 business days.${o.payment_method === "cod" || !o.payment_method ? ` Please keep ${Number(o.total_price).toLocaleString()} PKR ready for the courier.` : ""}`,
    delivered: (o) => `your order ${o.order_number} has been delivered. We hope you love it! Apply nightly for best results.`,
    cancelled: (o) => `your order ${o.order_number} has been cancelled. Reply here if this was a mistake.`,
};

export const waPhone = (phone) => `92${(phone || "").replace(/\D/g, "").replace(/^92/, "").replace(/^0/, "")}`;

export function statusWhatsAppLink(order, status = order.status) {
    const track = `${window.location.origin}/track-order?order=${order.order_number}`;
    const body = (MESSAGES[status] || MESSAGES.pending)(order);
    const text = `Assalamu Alaikum ${order.customer_name}, this is Resham Drops — ${body}\n\nTrack your order: ${track}`;
    return `https://wa.me/${waPhone(order.phone)}?text=${encodeURIComponent(text)}`;
}
